import React from 'react'
import { Col, Container, Row, Table } from 'react-bootstrap';
import star from '../../assets/images/market/market_star.svg';
import bitcoin from '../../assets/images/market/market_coin.svg';

import './market_styles/markettable.css';
import Paginationn from '../pagination/paginationn';

export default function MarketTable() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col>
            <Table responsive borderless className='text-start mark_table'>
              <thead className='mark_table_head'>
                <tr>
                  <th>Pair</th>
                  <th>Last Price</th>
                  <th>24h CHANGE</th>
                  <th>24h High</th>
                  <th>24h Low</th>
                  <th>24 VOL</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody className='mark_table_body'>
                <tr className='mark_dark_row'>
                  <td className='d-flex gap-2'>
                    <div className="mark_tab_imgs d-flex gap-2">
                      <img src={star} alt="star" />
                      <div className="mark_tab_bit d-flex justify-content-center">
                        <img src={bitcoin} alt="" />
                      </div>
                    </div>
                    Bitcoin
                  </td>
                  <td>$0.084</td>
                  <td>14.80%</td>
                  <td>14.80%</td>
                  <td>14.80%</td>
                  <td>$0.084</td>
                  <td className='last_td'>Detail</td>
                  <td className='last_td'>Traders</td>
                </tr>
                <tr>
                  <td className='d-flex gap-2'>
                    <div className="mark_tab_imgs d-flex gap-2">
                      <img src={star} alt="star" />
                      <div className="mark_tab_bit d-flex justify-content-center">
                        <img src={bitcoin} alt="" />
                      </div>
                    </div>
                    Bitcoin
                  </td>
                  <td>$0.084</td>
                  <td className='last_td'>14.80%</td>
                  <td>14.80%</td>
                  <td>14.80%</td>
                  <td>$0.084</td>
                  <td className='last_td'>Detail</td>
                  <td className='last_td'>Traders</td>
                </tr>
                <tr className='mark_dark_row'>
                  <td className='d-flex gap-2'>
                    <div className="mark_tab_imgs d-flex gap-2">
                      <img src={star} alt="star" />
                      <div className="mark_tab_bit d-flex justify-content-center">
                        <img src={bitcoin} alt="" />
                      </div>
                    </div>
                    Bitcoin
                  </td>
                  <td>$0.084</td>
                  <td>14.80%</td>
                  <td className='last_td_red'>14.80%</td>
                  <td>14.80%</td>
                  <td>$0.084</td>
                  <td className='last_td'>Detail</td>
                  <td className='last_td'>Traders</td>
                </tr>
                <tr>
                  <td className='d-flex gap-2'>
                    <div className="mark_tab_imgs d-flex gap-2">
                      <img src={star} alt="star" />
                      <div className="mark_tab_bit d-flex justify-content-center">
                        <img src={bitcoin} alt="" />
                      </div>
                    </div>
                    Bitcoin
                  </td>
                  <td>$0.084</td>
                  <td>14.80%</td>
                  <td>14.80%</td>
                  <td>14.80%</td>
                  <td>$0.084</td>
                  <td className='last_td'>Detail</td>
                  <td className='last_td'>Traders</td>
                </tr>
                <tr className='mark_dark_row'>
                  <td className='d-flex gap-2'>
                    <div className="mark_tab_imgs d-flex gap-2">
                      <img src={star} alt="star" />
                      <div className="mark_tab_bit d-flex justify-content-center">
                        <img src={bitcoin} alt="" />
                      </div>
                    </div>
                    Bitcoin
                  </td>
                  <td>$0.084</td>
                  <td>14.80%</td>
                  <td>14.80%</td>
                  <td>14.80%</td>
                  <td>$0.084</td>
                  <td className='last_td'>Detail</td>
                  <td className='last_td'>Traders</td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <div className="mt-5">
            <Paginationn />
          </div>
        </Row>
      </Container>
    </>
  )
}
